// HTTP API base URL.
//
// Empty string makes the fetch calls relative to the page's own origin. In
// dev (`yarn web` -> CRA on http://localhost:8080) that means the request
// goes to localhost:8080 and CRA's `proxy` field in package.json forwards it
// to the configured backend (Azure App Service today, or local Django if you
// flip the proxy). In production (served by Django at the Azure host or any
// future custom domain) it lands on the same origin as the backend. Either
// way no cross-origin / CORS hop is involved.
const apiUrl = ''

// WebSocket base. Derive from window.location at runtime so the host stays
// in sync with wherever the page is served — Azure direct, future custom
// domain, or localhost in dev. `wss:` if the page is https, otherwise `ws:`.
//
// NOTE for local dev: CRA's `proxy` field doesn't proxy WebSocket upgrades
// by default. If you need the live game websocket while running `yarn web`,
// either point this at the backend explicitly or add a setupProxy.js that
// proxies /ws with `ws: true`.
const videoWsUrl =
  (typeof window !== 'undefined' && window.location
    ? (window.location.protocol === 'https:' ? 'wss:' : 'ws:') +
      '//' +
      window.location.host
    : 'wss://huthut-sport-radar-40894.azurewebsites.net') +
  '/ws/sync-video-socket-web/'

export const APPCONFIG = {
  videoWsUrl,
  videoUrls: [
    'https://www.youtube.com/watch?v=yx9VaOXHxpA&pp=ygUOaG9yc2VzIHJ1bm5pbmc%3D',
  ],
  apiUrl,
  API: {
    gameTimer: '/game/game-timing-json/',
  },
}
